import type { ConversationThreadReadItem, JiraIssue } from "@rulebase/core/api";
import { Badge } from "@rulebase/core/components";
import { RiPriceTag3Line } from "react-icons/ri";
import {
  LinkedActivityRow,
  LinkedActivityRowIcon,
} from "./linked-activity-row";

const jiraStatusCategoryToLabel: Record<JiraIssue["status_category"], string> =
  {
    undefined: "No Category",
    new: "To Do",
    indeterminate: "In Progress",
    done: "Done",
  };

export function JiraIssueView(props: { item: ConversationThreadReadItem }) {
  // Type guard to ensure this is a Jira issue item
  if (props.item.type !== "jira_issue" || !props.item.jira_issue) {
    return null;
  }

  const jiraIssue = props.item.jira_issue;

  return (
    <LinkedActivityRow
      href={jiraIssue.service_desk_url || jiraIssue.url}
      leading={
        <LinkedActivityRowIcon>
          <img src="/img/integrations/jira.svg" alt="Jira" className="size-4" />
        </LinkedActivityRowIcon>
      }
      title={jiraIssue.summary}
      identifier={jiraIssue.issue_key}
      badges={
        <Badge className="shrink-0 gap-1 rounded-sm border-none bg-neutral-200 px-1.5 py-0.5 text-sm font-medium text-neutral-700">
          <RiPriceTag3Line className="size-3" />
          <span>{jiraStatusCategoryToLabel[jiraIssue.status_category]}</span>
        </Badge>
      }
      date={props.item.entity_created_at || props.item.created_at}
    />
  );
}
